import { Directive, TemplateRef } from '@angular/core';

@Directive({
	selector: '[uiSelectCustomOption]',
	standalone: false,
})
export class SelectCustomOptionDirective {
	constructor(public templateRef: TemplateRef<any>) {}
}
